import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { ProtocolUpsell } from './components/ProtocolUpsell';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-slate-950 font-sans selection:bg-amber-400 selection:text-slate-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <Testimonials data-id="element-4" />
      <PainSection data-id="element-5" />
      <ProductShowcase data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Pricing data-id="element-8" />
      <ProtocolUpsell data-id="element-9" />
      <MoreTestimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostOfInaction data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
      <SocialProofToast data-id="element-16" />
    </div>;
}